// Shared airspace classification/styling — used by the Data Manager map view
// and the Airspace Assessment tab, so colors and class buckets stay consistent.

export const AIRSPACE_CLASS_META = {
  CTR:           { color: '#00aaff', fillColor: '#0066cc' },
  ATZ:           { color: '#00ffaa', fillColor: '#009966' },
  SRA:           { color: '#ffaa00', fillColor: '#cc7700' },
  Danger:        { color: '#ff4444', fillColor: '#cc1111' },
  Restricted:    { color: '#ff88ff', fillColor: '#993399' },
  Prohibited:    { color: '#ff2222', fillColor: '#880000' },
  'Glider/Para': { color: '#88ffcc', fillColor: '#229966' },
  Other:         { color: '#aaaacc', fillColor: '#555577' },
};

// Classify airspace by name — mirrors _classify_airspace_type() in backend/routes/data_manager.py
export function classifyAirspace(name) {
  const n = (name || '').toUpperCase();
  if (n.includes('CTR'))                        return 'CTR';
  if (n.includes('ATZ'))                        return 'ATZ';
  if (n.includes('SRA') || n.includes('SPECIAL RULES')) return 'SRA';
  if (n.startsWith('FAD'))               return 'Danger';
  if (n.startsWith('FAR'))               return 'Restricted';
  if (n.startsWith('FAP'))               return 'Prohibited';
  if (n.includes('GLIDER') || n.includes('PARAGLID'))  return 'Glider/Para';
  return 'Other';
}

// Style function for airspace features
export function styleForAirspace(feature) {
  const cls = classifyAirspace(feature.name || '');
  const meta = AIRSPACE_CLASS_META[cls] || AIRSPACE_CLASS_META['Other'];
  return {
    color:       meta.color,
    fillColor:   meta.fillColor,
    weight:      1.5,
    opacity:     0.9,
    fillOpacity: 0.2,
    _class: cls,
  };
}

// Format an airspace vertical limit for display, e.g. "FL195", "GND", "1500 FT AGL"
export function formatAirspaceLimit(value, uom, ref) {
  if (value === null || value === undefined || value === '') return '—';
  if (uom === 'FL') return `FL${value}`;
  if (ref === 'SFC' && Number(value) === 0) return 'GND';
  return [value, uom, ref].filter(Boolean).join(' ');
}
